import { _ } from "libs";

import React, { useContext, useEffect } from "react";
import ReservationPageContext from "./reservationPageContext";
import PlayerItemSmall from "../../items/player/small";
import { Form, Field } from "react-final-form";
import { formatName } from "../../../libs/formatName";

const onSubmit = (values) => {
	console.log(values);
};

const BuddiesInvite = () => {
	const pageContext = useContext(ReservationPageContext);
	const {
		clubInfo,
		loadFriends,
		reservation: { params },
		friends,
		setPage,
	} = pageContext;

	useEffect(() => {
		loadFriends({ clubId: clubInfo.clubId });
	}, []);

	return (
		<Form
			onSubmit={onSubmit}
			render={({ handleSubmit, form, submitting, pristine, values }) => (
				<form className="wizard inviteBuddiesWizard" onSubmit={handleSubmit}>
					<div className="wizardHeader">
						<div
							className="back"
							onClick={() => {
								setPage("partner");
							}}
						/>
						<div className="title">{_("bookingWizard.inviteBuddies.heading")}</div>
					</div>
					<div className="wizardBody">
						<div className="msg info">{_("bookingWizard.inviteBuddies.description")}</div>
						{/* <div className="horizontalFlex">
							<h6>Buddies</h6>
							<div>
								<a onClick={() => alert("TODO @BAZO")}>Select All</a>
							</div>
						</div> */}
						<div className="list players">
							{friends.map((friend) => (
								<div className="cell" key={friend.userId}>
									{/* TODO @BAZO make playerItem clickable to toggle checkbox */}
									<PlayerItemSmall
										name={formatName(friend.firstName, friend.lastName)}
										photoUrl={friend.photoUrl}
									/>
									<Field name="userIds" type="checkbox" value={friend.userId}>
										{({ input, meta }) => <input {...input} type="checkbox" id={friend.userId} />}
									</Field>
								</div>
							))}
						</div>
					</div>
					<div className="wizardFooter">
						<button className="button" type="submit" disabled={submitting || pristine}>
							Invite
						</button>
					</div>
				</form>
			)}
		/>
	);
};
export default BuddiesInvite;
